<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>account_tree</md-icon>
                    </div>
                    <h4 class="title"></h4>
                    <div style="text-align: right">
                        <md-button
                            class="md-primary md-sm"
                            style="margin: 20px 20px 0 20px"
                            @click.native="editOpen()"
                        >
                            Adicionar
                        </md-button>
                        <md-button
                            class="md-just-icon md-simple"
                            style="float:right; margin: 10px 0 0 0"
                        >
                            <md-icon>settings</md-icon>
                        </md-button>
                        <div style="float: right;">
                            <md-field>
                                <md-input
                                    type="search"
                                    clearable
                                    style="width: 200px"
                                    placeholder="Filtrar"
                                >
                                </md-input>
                            </md-field>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <v-draggable-treeview
                        v-model="items"
                        :editable="true"
                        :openCallback="readChild"
                        :editCallback="editOpen"
                        :deleteCallback="handleDelete"
                    ></v-draggable-treeview>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando itens {{ from }} a {{ to }} de um total de
                            {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>

        <form @submit.prevent="editSubmit()">
            <modal v-if="editModal" @close="editCancel()">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFields"
                            :key="field"
                        >
                            <md-field
                                v-if="fieldTypes[field] != 'datetime-local'"
                            >
                                <label>{{ columnNames[field] }}</label>
                                <md-input
                                    v-model="editModalModel[field]"
                                    :type="fieldTypes[field]"
                                ></md-input>
                            </md-field>
                            <md-datepicker
                                v-model="editModalModel[field]"
                                v-else
                                md-immediately
                            >
                                <label>{{ columnNames[field] }}</label>
                            </md-datepicker>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="editCancel()">
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import { Pagination, Modal, VuetifyDraggableTreeview } from '@/components'

import { Node as Model } from '@/models/node.model'
const model = 'nodes'

export default {
    created() {
        this.readEntities()
    },
    components: {
        'v-draggable-treeview': VuetifyDraggableTreeview,
        Modal,
        Pagination
    },
    data() {
        return {
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields),
            fieldTypes: Model.fieldTypes,
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            }
        }
    },
    computed: {
        ...mapState({
            queriedData: state => state[model].page
        }),
        items() {
            return this.queriedData.results
        },
        to() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[
                    this.queriedData.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[0].id
            else return 0
        },
        total() {
            return this.queriedData.count
        }
    },
    methods: {
        ...mapActions(model, {
            createEntity: 'create',
            readEntities: 'read',
            updateEntity: 'update',
            deleteEntity: 'delete'
        }),
        editOpen(item) {
            if (item) {
                this.editModalTitle = 'Editando #' + item.id

                this.editModalModel = { ...this.editModalModel, ...item } // copy object values
            } else {
                this.editModalTitle = 'Novo nó'
            }
            this.editModal = true
        },
        editCancel() {
            this.editModal = false
            this.editModalModel = new Model()
        },
        async editSubmit() {
            let editError

            if (this.editModalModel.id) {
                editError = await this.updateEntity({
                    ...this.editModalModel
                })
            } else {
                editError = await this.createEntity({
                    ...this.editModalModel
                })
            }

            if (editError)
                this.$notify({
                    message:
                        'Erro ao ' +
                        (this.editModalModel.id ? 'editar' : 'criar') +
                        ' produto.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message:
                        'Produto ' +
                        (this.editModalModel.id ? 'editado' : 'criado') +
                        ' com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })

                this.editModal = false
                this.editModalModel = new Model()
                this.readEntities()
            }
        },
        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteEntity({ id: item.id })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readEntities()
                    }
                }
            })
        },

        readChild(item) {
            return this.readEntities({ item })
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                this.readEntities({ page: val.currentPage })
            },
            deep: true
        }
    }
}
</script>
<style></style>
